module.exports = __webpack_public_path__ + "static/media/sent.20f23298.svg";